import { render, staticRenderFns } from "./DeviceRealBasicInfo.vue?vue&type=template&id=a6a97b9e&scoped=true"
import script from "./DeviceRealBasicInfo.vue?vue&type=script&lang=js"
export * from "./DeviceRealBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./DeviceRealBasicInfo.vue?vue&type=style&index=0&id=a6a97b9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a97b9e",
  null
  
)

export default component.exports